import { render, staticRenderFns } from "./template.vue?vue&type=template&id=85da593a&scoped=true&"
import script from "@/Components/Modules/Administration/AdminNavigation/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Modules/Administration/AdminNavigation/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Modules/Administration/AdminNavigation/style.scss?vue&type=style&index=0&id=85da593a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85da593a",
  null
  
)

export default component.exports